module.exports = __webpack_public_path__ + "img/stump-sel.c38fb6a4.svg";